<kendo-dialog maxWidth="90vw" [title]="$title() ?? ''" [width]="$width()" [height]="$height()" (close)="onClose()">
  <ng-content select="[dialog-body]" />
  <kendo-dialog-actions [layout]="$layout()">
    <ng-content select="[dialog-actions]" />
  </kendo-dialog-actions>
</kendo-dialog>
